import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Constants } from 'src/shared/utilities/constants.util';
import { EntityAdminConfig } from 'src/shared/Baseclasses/entity-admin.component';
import { Measure } from 'src/shared/models/measure.model';
import { MeasureService } from 'src/shared/services/measure.service';
import { PageLayoutService } from 'src/shared/services/page-layout.service';
import { RemoveMasterListFailure } from 'src/shared/enum/remove-master-list-failure.enum';

@Component({
    selector: 'smt-measures',
    templateUrl: './measures.component.html',
    styleUrls: ['./measures.component.scss']
})
export class MeasuresComponent extends EntityAdminConfig implements OnDestroy, OnInit {
    @ViewChild('measureEditForm') public measureEditForm: NgForm;

    enableCode: boolean;
    measure:Measure;
    measures: Measure[];
    mostRecent: boolean;
    selectedId : number;
    selectedCode: string;
    selectedDescription: string;
    selectedDisplayUnits: string;
    hasTotalCalculation: boolean;
    selectedMeasure: string;
    selectedModifiedDate : Date;
    selectedModifiedBy: string;
    addNew = false;
    title : HTMLElement;
    showCostCenterWarning:boolean=false;
    costCenterNames: string[];
    costCenterListModalActive: boolean = false;
    measureName:string;
    
    constructor(private _measureService: MeasureService, private _pageLayout: PageLayoutService,@Inject(DOCUMENT) document) {
        super(_pageLayout);
    }

    ngOnDestroy() {
        super.cleanUp();
    }


    ngOnInit() {
        super.initialize(
            Constants.Measures,
            [ "Measure", "Code", "Last Modified" ],
            async() => this.setSelectedMeasureValues(),
            async(mostRecent: boolean) => this.refreshMeasureList(mostRecent),
            async() => this.appendMeasureList(),
            async() => this.saveMeasure(),
            () => this.setCurrentSelectionLabel(),
            () => { return "Remove"; });
    }

    onCancel() {
        super.onCancel();
        this.setSelectedMeasureValues();
        this.resetForm();
    }

    onSelection(measure: Measure) {
        this.resetForm();
        super.onSelection(measure);
    }

    async saveMeasure() {
        if (!this.selection) {
            return;
        }

        let mostRecent = this.selection.id == 0;

        this.measure = new Measure();
        this.measure.id = this.selectedId;
        this.measure.factor = this.selectedMeasure;
        this.measure.code = this.selectedCode;
        this.measure.description = this.selectedDescription;
        this.measure.displayUnits = this.selectedDisplayUnits;
        this.measure.hasTotalCalculation = this.hasTotalCalculation;
        this.title =  document.getElementById('measuretitle') as HTMLElement;

        let result = await this._measureService.setMeasure(this.measure);
        if (result.errorMessage) {
            super.setErrorMessage(result.errorMessage);
        }
        else if(result.id>0){
            this.selection.id = result.id;
            this.selection.code = result.code;
            this.selection.factor = result.factor;
            this.selection.description = result.description;
            this.selection.displayUnits = result.displayUnits;
            this.selection.hasTotalCalculation = result.hasTotalCalculation;    
            await super.refreshAdminList(mostRecent, true);
            
        }
        else {
            super.setErrorMessage("Measure failed to save.");
        }
    }

    async appendMeasureList(): Promise<void> {
        let result = await this._measureService.getMeasuresInfiniteScroll(
            false,
            this.offset,
            this.itemsPerPage,
            this.searchText,
            this.selectedFilter,
            this.getSortOrderString());

        this.measures = this.measures.concat(result);
    }

  onAddMeasureClick() {
    this.selection = {
      id: 0,
      code: '',
      description: '',
      modifiedByUserName: '',
      factor:'',
      modifiedDate: null
    };

    this.addNew = true;
    this.showAdminActionWindow = true;
    super.limitAdminActionLabel();
    this.setSelectedMeasureValues();
    this.showCostCenterWarning = false;
  }

  async removeMeasure()
  {
        if(!this.selection) {
            return;
        }

    let result = await this._measureService.deleteMeasure(this.selection.id);
    if (result == RemoveMasterListFailure.CostCenterAssociation)
      this.showCostCenterWarning = true;
      this.confirmModalActive = false;
    if (result == RemoveMasterListFailure.None) {
            super.refreshAdminList(false, false);
        }
        else {
            super.setErrorMessage("Measure delete failed.");
        }
    }
    async getCostCentersByMeasureId(openModal:boolean) {
        if (!this.selection) {
          return;
        }
      this.measureName=this.selection.factor;
      this.costCenterNames = await this._measureService.getCostCentersByMeasureId(this.selection.id);
      this.costCenterListModalActive = openModal;
      }
    async refreshMeasureList(mostRecent: boolean): Promise<Measure[]> {
        let result = await this._measureService.getMeasuresInfiniteScroll(
            mostRecent,
            this.offset,
            this.itemsPerPage,
            this.searchText,
            this.selectedFilter,
            this.getSortOrderString());
        this.measures = result;
        this.setSelectedMeasureValues();
        this.resetForm();
        return result;
    }

    resetForm() {
        this.addNew = false;

        if (!this.measureEditForm) {
            return;
        }
        Object.keys(this.measureEditForm.controls).forEach(control => {
            this.measureEditForm.controls[control].markAsPristine();
        });
    }

    setCurrentSelectionLabel(): string {
        if (!this.selection) {
            return "";
        }

        if (this.selection.id == 0) {
            return "New Measure";
        }

        return this.selection.factor;
    }

    setSelectedMeasureValues() {
        super.setErrorMessage("");

        if (this.selection) {
            this.selectedMeasure = this.selection.factor;
            this.selectedId = this.selection.id;
            this.selectedCode = this.selection.code;
            this.selectedDescription = this.selection.description;
            this.selectedDisplayUnits = this.selection.displayUnits;
            this.hasTotalCalculation = this.selection.hasTotalCalculation;
            this.enableCode = this.selection.id == 0;
        }
        else {
            this.selectedId = 0,
                this.selectedCode = "";
            this.selectedDescription = "";
            this.selectedMeasure = "";
            this.selectedDisplayUnits = "";
            this.hasTotalCalculation = null;
            this.enableCode = true;
        }
      this.showCostCenterWarning=false;
    }
}
